import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/market/public/";
const CFDURL = "/sapi/v4/cfd/";

//获取交易对
export function get_symbol(config?) {
  return XtAxios4.get(URL + `symbol`, config);
}

//获取24h行情统计
export function get_ticker24h(config?) {
  return XtAxios4.get(URL + `ticker/24h`, config);
}


//获取排行榜配置
export function get_topConfig(config?) {
  return XtAxios4.get(URL + `top/config`, config);
}

//获取所有板块
export function get_plate(config?) {
  return XtAxios4.get(URL + `plate`, config);
}

//查询近期成交列表
export function get_tradeRecent(config?) {
  return XtAxios4.get(URL + `trade/recent`, config);
}

//获取深度信息
export function get_depth(config?) {
  return XtAxios4.get(URL + `depth`, config);
}

//获取服务器时间
export function get_time(config?) {
  return XtAxios4.get(URL + `time`, config);
}

//获取K线数据
export function get_kline(config) {
  return XtAxios4.get(URL + `kline`, config);
}

//获取CFD K线数据
export function get_cfd_kline(config) {
  return XtAxios4.get(CFDURL + "market/klines", config);
}


//获取CFD 24h行情统计
export function get_cfd_ticker24h(config?) {
  return XtAxios4.get(CFDURL + "market/ticker/24h", config);
}

//获取交易对
export function get_cfd_symbol(config?) {
  return XtAxios4.get(CFDURL + `public/symbol`, config);
}
